import React, { useEffect } from 'react';

function Layout({ title, Component }) {
    return (
        <>
            <div style={{ minHeight: '100vh' }}>
                <Component />
            </div>
        </>
    );
}

export default Layout;
